import React from 'react';
import styled from 'styled-components';
import GenericModal from './GenericModal';

const AboutText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const AboutUsModal = ({ isOpen, onClose }) => {
  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      title="About Us"
      zIndex={1000001} // Ensure it's above SettingsModal if opened from there
      containerMaxWidth="350px"
      contentPadding="20px" // Re-apply specific padding for the content area
    >
      <AboutText>
        PXL app is a free mining platform, zero investment, zero risk.
      </AboutText>
      <AboutText>
        Upgrade your miner to quickly mine $SHIBA INU, with real-time earnings!
      </AboutText>
      <AboutText>
        Invite friends to earn 30% profit sharing and easily double your income!
      </AboutText>
      <AboutText>
        🚀 Join now to start your wealth journey!
      </AboutText>
    </GenericModal>
  );
};

export default AboutUsModal;
